import { render, staticRenderFns } from "./drop-zone-input.vue?vue&type=template&id=4d331b48&"
import script from "./drop-zone-input.vue?vue&type=script&lang=js&"
export * from "./drop-zone-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports